<template>
    <div id="wrapper">
        <navbar />
        <div id="page-wrapper" class="gray-bg dashbard-1" style="min-height: 100vh;">
            <top-bar />
            <div class="row wrapper border-bottom white-bg page-heading pt-3">
                <breadcrumb />
                <comment />
            </div>

            <div class="row">
                <div class="col-lg-12">
                    <div class="wrapper wrapper-content animated fadeInRight">
                        <router-view/>
                    </div>
                </div>
            </div>
            <div class="footer">
                <div class="float-right">
                    Wersja <strong>0.1.100</strong> z dnia <strong>2026-07-13 12:28:13</strong>.
                </div>
                <div>
                    <strong>Copyright</strong> Cosmo Group Sp. z o.o. Sp. K. - {{ new Date().getFullYear() }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Navbar from '@/components/Navbar'
import TopBar from '@/components/TopBar'
import Comment from '@/components/Comment'
import Breadcrumb from '@/components/Breadcrumb'
import { mapActions } from 'vuex'

export default {
    name: 'wrapper',
    components: {
        Navbar,
        TopBar,
        Comment,
        Breadcrumb
    },
    beforeCreate() {
        document.querySelector( 'body' ).classList.remove( 'gray-bg' )
    },
    created() {
        this.setUserData()
        window.addEventListener( 'resize', this.resize )
        if ( window.innerWidth < 720 ) {
            document.querySelector( 'body' ).classList.add( 'body-small' )
        }
    },
    methods: {
        ...mapActions( 'users', [ 'setUserData' ] ),
        resize() {
            if ( window.innerWidth < 720 ) {
                document.querySelector( 'body' ).classList.add( 'body-small' )
            } else {
                document.querySelector( 'body' ).classList.remove( 'body-small' )
            }
        }
    },
    beforeDestroy() {
        document.removeEventListener( 'resize', this.resize )
    }
}
</script>
